import { createStore, createLogger } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    route: null,
    admin: false,
    userInfo: null,
    loggedIn: false,
    toggle: {
      signUp: false,
      helpButton: false,
      contactPage: false
    }
  },
  // Mutations are functions that effect the STATE.
  // Convention to be in all caps
  mutations: {
    SET_ROUTE(state, route) {
      state.route = route;
    },
    SET_ADMIN(state, admin) {
      state.admin = admin
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_LOGIN(state, loggedIn) {
      state.loggedIn = loggedIn
    }
  },
  // Actions are functions that you call throughout your application that call mutations. 
  actions: {
    setRoute({ commit }, route) {
      commit('SET_ROUTE', route)
    },
    setAdmin({ commit }, admin) {
      commit('SET_ADMIN', admin)
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setLoggedIn({ commit }, loggedIn) {
      commit('SET_LOGIN', loggedIn)
    }
  },
  modules: {},
  plugins: process.env.NODE_ENV != 'production' ? [createLogger(), createPersistedState({
    storage: window.sessionStorage,
  })] : [createPersistedState({
    storage: window.sessionStorage,
  })]
})
